import axios from 'axios'

export default {
    download(filter) {
        return axios.download('/api/products/export',
            {
                no: filter.text,
                name: filter.text,
                model: filter.text
            });
    },
    getProducts(page, text) {
        return axios.get('/api/products',
            {
                params: {
                    page: page,
                    no: text,
                    name: text,
                    model: text
                }
            });
    },
    getProduct(id) {
        return axios.get(`/api/products/${id}`);
    },
    saveProduct(id, product) {
        if (id) {
            return axios.put(`/api/products/${id}`, product);
        }
        return axios.post('/api/products', product);
    },
    deleteProduct(id) {
        return axios.delete(`/api/products/${id}`);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/masters/products/api.js